webModule.factory("QuoteIntegrationLocal", function() {
    //for use to avoid calling the RESTful template API for quote integration data
    // use locally within the UI and not "integrating" with Menu or some other
    // app.. "integrating" with itself ;-)
    var VehicleInfo = function() {
        this.vin = "";
        this.odometer = 0;
        this.wMonths=0;
        this.wMiles=0;
        this.vehicleType='AUTO';
    };

    var BuyerInfo = function(){
        this.customerNumber = "";
        this.firstName = "";
        this.middleName = "";
        this.lastName = "";
        this.address1 = "";
        this.address2 = "";
        this.state = "";
        this.zip = "";
        this.city = "";
        this.phone1 = "";
    };

    var FinancialInfo = function(){
        this.financingMonths = 0;
        this.financingAPR = 0.0;
        this.amountFinanced = 0.0;
        this.sellingPrice = 0.0;
        this.MSRP = 0.0;
    };

    var BusinessInfo = function() {
        this.businessName = "";
        this.driverFirstName = "";
        this.driverLastName = "";
        this.address1 = "";
        this.address2 = "";
        this.state = "";
        this.zip = "";
        this.city = "";
        this.phone1 = "";
    };

    var QuoteIntegrationInfo = function(){
        this.dateOfSale = new Date();
        this.saleType = "";
        this.vehicleInfo = new VehicleInfo();
        this.primaryBuyerInfo = new BuyerInfo();
        this.businessInfo = new BusinessInfo();
        this.financialDatas = [];
        this.providerSpecific = null;
        this.financialDatas.push(new FinancialInfo());
        this.coBuyerInfo = new BuyerInfo();
    }

    return QuoteIntegrationInfo;
});
